import axios from "axios";
import config from "../Constants/Config";

const BACKEND_URL = process.env.REACT_APP_API_URL + config.tvAuth;

export async function SendCode(
    code: string,
    userId: string,
    abortController: AbortController
): Promise<boolean> {
    const encodedCode = encodeURIComponent(code.trim());
    const encodedUserId = encodeURIComponent(userId);

    try {
        const response = await axios.post(
            `${BACKEND_URL}login/${encodedCode}/${encodedUserId}/`,
            undefined,
            { signal: abortController.signal }
        );

        // The legacy endpoint's contract is a JSON boolean. Do not coerce other
        // response bodies: strings and error objects are truthy and previously
        // made failed legacy activations look successful.
        return response.data === true;
    } catch {
        return false;
    }
}
